import { createContext, useContext } from "react";

/**
 * 모바일 셸 안에서 그려지는 중인지 — 셸 앱바가 화면 제목을 이미 보여 주므로
 * PageHeader 는 셸 안에서 제목 줄을 숨기고 오른쪽 동작 버튼만 남긴다.
 * setTitle: 메뉴 정보(pageMeta)가 없는 화면(예: 계약서)은 PageHeader 가 자기 제목을 앱바로 올린다.
 */
type ShellApi = { setTitle: (title: string | null) => void };
export const MobileShellContext = createContext<ShellApi | null>(null);
export const useInMobileShell = () => useContext(MobileShellContext) !== null;
export const useMobileShell = () => useContext(MobileShellContext);
